import { Outlet } from "react-router-dom"
import "@fontsource/open-sans/latin-400.css"
import "@fontsource/open-sans/latin-500.css"
import "@fontsource/open-sans/latin-600.css"
import "@fontsource/open-sans/latin-700.css"
import Header from "@/sections/Header"
import Footer from "@/sections/Footer"

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <Outlet />
      <Footer />
    </div>
  )
}

export default App
